import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { Glyphicon, Alert } from 'react-bootstrap';

import { QuerySingleJobGQL } from '../graphql/index';
import JobFormEnhance from './JobFormEnhance';
import TicketCompactList from '../../../tickets/components/TicketCompactList';

/* eslint-disable react/forbid-prop-types */
const propTypes = {
  job: PropTypes.object.isRequired,
  tickets: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const JobEditor = (props) => {
  const {
    job,
    tickets,
    onSubmit,
    onCancel,
  } = props;

  return (
    <div>
      <h2>
        Job: {job.job_number}
      </h2>
      <div>
        <Alert bsStyle="warning">
          <Glyphicon glyph="warning-sign" />
          {' '}
          <span>Tickets to be updated.</span>
          <TicketCompactList tickets={tickets} />
        </Alert>
        <p>
          Changing the lease of this job will update the well of all tickets on this job. There
          are two cases:
        </p>
        <ol>
          <li>
            If the well already exists on the lease the ticket will be updated to point to
            the existing well.
          </li>
          <li>
            If the well does not exist on the new lease the well will be created on the new lease.
            The ticket will then point to the new well on the lease.
          </li>
        </ol>
      </div>
      <JobFormEnhance job={job} onSubmit={onSubmit} onCancel={onCancel} />
    </div>
  );
};

const enhance = compose(QuerySingleJobGQL);

JobEditor.propTypes = propTypes;

export default enhance(JobEditor);
